
// Initialize AOS
document.addEventListener('DOMContentLoaded', function () {
  AOS.init({
    once: true,
    duration: 1700,
    offset: 170,
  });

  const container = document.querySelector('.skin-transform_main');
  document.querySelector('.slider').addEventListener('input', (e) => {
    container.style.setProperty('--position', `${e.target.value}%`);
  })

});

// 05-03-2025 Review slider 
var selectors$6 = {
  swiper: ".skin-reviews_slider",
  navigationNext: ".swiper-button-next",
  navigationPrev: ".swiper-button-prev",
};

import(flu.chunks.swiper).then(function (_ref2) {
  var Swiper = _ref2.Swiper,
      Navigation = _ref2.Navigation,
      EffectFade = _ref2.EffectFade;

  var swiperOptions = {
    slidesPerView: 1,
    spaceBetween: 61,
    modules: [Navigation, EffectFade],
    navigation: {
      nextEl: selectors$6.navigationNext,
      prevEl: selectors$6.navigationPrev,
    },
  };

  // Initialize Swiper
  new Swiper(selectors$6.swiper, swiperOptions);
});



var selectors$7 = {
  swiper: ".product__media",
  navigationNext: ".swiper-button-next",
  navigationPrev: ".swiper-button-prev",
};

import(flu.chunks.swiper).then(function (_ref2) {
  var Swiper = _ref2.Swiper,
      Navigation = _ref2.Navigation,
      EffectFade = _ref2.EffectFade;

  var swiperOptions = {
    slidesPerView: 1,
    spaceBetween: 61,
    navigation: {
      nextEl: selectors$7.navigationNext,
      prevEl: selectors$7.navigationPrev,
    },
  };

  // Initialize Swiper
  new Swiper(selectors$7.swiper, swiperOptions);
});


// 05-03-2025 home blog section slider \
  var selectors ={
  contaier :".skin_blogs_slider",
  navigationdot: ".swiper-pagination"
}
import(flu.chunks.swiper).then(function (_ref2) {
   var Swiper = _ref2.Swiper,
    Pagination = _ref2.Pagination;
  var swiperOptions = {
    modules: [Pagination],
    slidesPerView: 1,
    spaceBetween: 18,
    pagination: {
     el: selectors.navigationdot,
     clickable: true,
        renderBullet: function renderBullet(_, className) {
              return "\n   <button class=\"".concat(className, "\" type=\"button\">\n  <div class=\"slideshow-navigation__dot-loader\"></div>\n  </button>");
            },
    },
    breakpoints: {
        641: {
            slidesPerView: 2,
             spaceBetween: 18,
        },
        992: {
            slidesPerView: 3,
             spaceBetween: 18,
        }
    }
  };
  new Swiper(selectors.contaier, swiperOptions);
});

// 05-03-2025 image-hero Scroll next section
$(document).ready(function () {
$('body').on('click','.image-hero-scroll-arrow',function(e){
    e.preventDefault();
    var bannerHeight = $(".new_hero_wrapper").innerHeight();
    var offerBarHeight = $(".announcement-bar").innerHeight();
    $("html, body").animate({ scrollTop: bannerHeight + offerBarHeight }, '800');
  });
});

// Cart open close Menu
$('body').on('click', '.moblie-cart', function(e) {
  e.preventDefault();
  const $drawerMenu = $('.drawer-menu');
  const $menuIcon = $('.header__menu-icon');
  const $body = $('body');

  $drawerMenu.removeClass('active visible');
  $menuIcon.attr({
    'aria-label': 'Open menu modal',
    'aria-expanded': 'false'
  });
  $body.css({
    "overflow": "",
    "top": ""
  }).removeClass('scroll-lock');
});


// skin-video-with-text [video plus]
$('body').on('click', '.media_video_wpr', function(e) {
  var mediaVideo = $(this).find(".video-on");  // Target only the video within the clicked container
  mediaVideo.each(function (k, v) {
    if (v.paused) {
        v.play();
      $(this).parent().find('.video_play_btn').hide(); // Hide play button
    } else {
      v.pause();
      $(this).parent().find('.video_play_btn').show(); // Show play button
    }
  });
});

// counter number js
if ($("body").find('.skin-numbers').length > 0) {
var a = 0;
$(window).scroll(function () {
    var oTop = $(".skin_number_block").offset().top - window.innerHeight;
    if (a === 0 && $(window).scrollTop() > oTop) {
        $(".counter").each(function () {
            var $this = $(this);
            var countTo = $this.attr("data-number");
            if (!countTo || isNaN(countTo)) {
                console.error("Invalid data-number for counter:", $this);
                return;
            }
            $({ countNum: parseInt($this.text().replace(/,/g, ""), 10) }).animate(
                {
                    countNum: parseInt(countTo, 10)
                },
                {
                    duration: 6000,
                    easing: "swing",
                    step: function (now) {
                        $this.text(Math.ceil(now).toLocaleString("en"));
                    },
                    complete: function () {
                        $this.text(Math.ceil(this.countNum).toLocaleString("en"));
                    }
                }
            );
        });
        a = 1;
    }
});
};

// Product Page Tab 
$('ul.tabs li').click(function () {
    var tab_id = $(this).attr('data-tab');
    $(this).closest('.has_parent').find('ul.tabs li').removeClass('current');
    $(this).closest('.has_parent').find('.tab_content').removeClass('current');
    $(this).addClass('current');
    $("#" + tab_id).addClass('current');
}); 


document.querySelectorAll('p').forEach((el) => {
    if (el.innerHTML.trim() === '&nbsp;') {
        el.style.display = 'none';
    }
});

document.addEventListener("DOMContentLoaded", function() {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname != window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noopener noreferrer';
    }
  }
});


// ===================  blog category randomly changing in every refresh ======================= //

document.addEventListener("DOMContentLoaded", function () {
  const categories = document.querySelectorAll(".blog-category");
  const dataInfoValue = categories.length > 0 ? categories[0].getAttribute("data-limit") : 0;
  if (categories.length > 0) {
    const totalToShow = parseInt(dataInfoValue, 10);
    let indexes = [];
    while (indexes.length < totalToShow && indexes.length < categories.length) {
      let rand = Math.floor(Math.random() * categories.length);
      if (!indexes.includes(rand)) {
        indexes.push(rand);
      }
    }
    console.log("Show indexes", indexes);
    categories.forEach((cat, i) => {
      cat.style.display = indexes.includes(i) ? "block" : "none";
    });
    // 05-03-2025 home blog section slider \
    var selectors ={
      contaier :".skin_blogs_slider",
      navigationdot: ".swiper-pagination"
    }
    import(flu.chunks.swiper).then(function (_ref2) {
      var Swiper = _ref2.Swiper,
        Pagination = _ref2.Pagination;
      var swiperOptions = {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 18,
        pagination: {
        el: selectors.navigationdot,
        clickable: true,
            renderBullet: function renderBullet(_, className) {
                  return "\n   <button class=\"".concat(className, "\" type=\"button\">\n  <div class=\"slideshow-navigation__dot-loader\"></div>\n  </button>");
                },
        },
        breakpoints: {
            641: {
                slidesPerView: 2,
                spaceBetween: 18,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 18,
            }
        }
      };
      new Swiper(selectors.contaier, swiperOptions);
    });
  }
});